import { TrendHistoryItem } from "src/core/models/analysis/trend-analysis/trend-history-item-model";

export class FilterHistoryAdd {
  static readonly type = '[TrendAnalysisFilterHistory] FilterHistoryAdd';
  constructor(public payload: TrendHistoryItem) {}
}

export class FilterHistoryBack {
  static readonly type = '[TrendAnalysisFilterHistory] FilterHistoryBack';
}

export class FilterHistoryForward {
  static readonly type = '[TrendAnalysisFilterHistory] FilterHistoryForward';
}

export class FilterHistoryReset {
  static readonly type = '[TrendAnalysisFilterHistory] FilterHistoryReset';
}

export class FilterHistoryClear {
  static readonly type = '[TrendAnalysisFilterHistory] FilterHistoryClear';
}
